import { licensingEngineApi } from 'licensing-engine-sdk'

const getLicenses = async () => {
  return await licensingEngineApi('domain').getLicenses[''].GET()
}

export default getLicenses
